module.exports = __webpack_public_path__ + "img/Group 1000000931.9f2447b1.svg";